__turbopack_context__.v({
  "list": "m-list-module-scss-module__4jleXW__list",
  "placeholder": "m-list-module-scss-module__4jleXW__placeholder",
});
